import * as React from 'react';

import {ButtonCard} from 'shells/card/button-card';

import type {AgentKey} from '../helpers';

import {buildAgentDescription, buildAgentHeader, getAgentAvatar} from './helpers';

import styles from './agent-card.module.css';

type Props = {
    agentKey: AgentKey;
    onClick: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
    isDisabled?: boolean;
    isComingSoon?: boolean;
};

export function AgentCard(props: Props) {
    const AgentAvatar = getAgentAvatar(props.agentKey);

    return (
        <ButtonCard
            fitHeight={true}
            isFullWidth={true}
            onClick={props.onClick}
            isDisabled={props.isDisabled}
            hasOffWhiteBackground={props.isDisabled}
        >
            <div className='flex gap-4 pad-12'>
                <div className={styles['agent-avatar-container']}>
                    <AgentAvatar size={70} />
                </div>
                <div className='flex align-center flex-dir-col gap-4 full-height'>
                    {buildAgentHeader(props.agentKey, Boolean(props.isComingSoon))}
                    {buildAgentDescription(props.agentKey)}
                </div>
            </div>
        </ButtonCard>
    );
}
